const urlToProductId: Record<string, number> = {
  "underwriting-engine": 23,
  "risk-concentrations": 33,
  "risk-pricing-engine": 24,
  "portfolio-performance": 72,
};

export function mapUrlToProductId(urlKey: string): number | undefined {
  return urlToProductId[urlKey];
}
